export default __webpack_public_path__ + "static/media/Turco-table.35ae56d2.webp";